import React, { useState } from 'react';
import { Button, Card, Modal, Form as BootstrapForm, Row } from 'react-bootstrap';
import { Formik } from "formik";
import axios from 'axios';
import * as Yup from 'yup';
import { FileUploader, TextInput } from '../components/Form.js';

const FieldTeamMemberModal = (props) => {

  // Regex validators.
  const phoneRegex = /^((\+\d{1,3}(-| )?\(?\d\)?(-| )?\d{1,3})|(\(?\d{2,3}\)?))(-| )?(\d{3,4})(-| )?(\d{4})(( x| ext)\d{1,5}){0,1}$/;

  return (
    <>
    <Formik
      initialValues={{
        first_name: '',
        last_name: '',
        phone: '',
        agency_id: '',
        operational: props.state.incident.training ? false : true,
        training: props.state.incident.training ? true : false,
        incident: props.state ? props.state.incident.id : 'undefined',
        organization: props.state ? props.state.organization.id : 'undefined',
      }}
      enableReinitialize={true}
      validationSchema={Yup.object({
        first_name: Yup.string()
          .max(50, 'Must be 50 characters or less')
          .required('Required'),
        last_name: Yup.string()
          .max(50, 'Must be 50 characters or less')
          .required('Required'),
        phone: Yup.string()
          .matches(phoneRegex, "Phone number is not valid")
          .required('Required'),
        agency_id: Yup.string()
          .max(20, 'Must be 20 characters or less'),
      })}
      onSubmit={(values, { resetForm }) => {
        axios.post('/evac/api/evacteammember/', values)
        .then(response => {
          let selected_list = [...props.selected];
          selected_list.push({id:[response.data.id], label:response.data.first_name + " " + response.data.last_name + (response.data.agency_id ? " (" + response.data.agency_id + ")" : ""), is_assigned:false})
          props.setSelected(selected_list);
          if (props.setFieldValue) {
            props.setFieldValue('team_members', [...props.values.team_members, response.data.id]);
          }
          if (props.setSelectedCount) {
            props.setSelectedCount((prevState) => ({...prevState, disabled:props.selectedCount.count > 0 ? false : true}));
          }
          props.handleCloseShowAddTeamMember();
          resetForm();
        })
        .catch(error => {
          props.setShowSystemError(true);
        });
      }}
    >
      {formikProps => (
        <Modal show={props.showAddTeamMember} onHide={props.handleCloseShowAddTeamMember}>
          <Modal.Header closeButton>
            <Modal.Title>Add Team Member</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <BootstrapForm>
              <Row className="gx-2">
                <TextInput
                  type="text"
                  label="First Name*"
                  name="first_name"
                  id="first_name"
                  xs="6"
                />
                <TextInput
                  type="text"
                  label="Last Name*"
                  name="last_name"
                  id="last_name"
                  xs="6"
                />
              </Row>
              <Row className="mt-3 gx-2">
                <TextInput
                  type="text"
                  label="Phone*"
                  name="phone"
                  id="phone"
                  xs="6"
                />
                <TextInput
                  type="text"
                  label="Agency ID"
                  name="agency_id"
                  id="agency_id"
                  xs="6"
                />
              </Row>
            </BootstrapForm>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="primary" onClick={() => formikProps.submitForm()}>Save</Button>
            <Button variant="secondary" onClick={props.handleCloseShowAddTeamMember}>Close</Button>
          </Modal.Footer>
        </Modal>
      )}
    </Formik>
    </>
  );
};

export { FieldTeamMemberModal, }
